import { Box, Chip, IconButton, styled } from "@mui/material";
import { Categories, Checklist } from "models/Checklist";
import EditIcon from "@mui/icons-material/EditOutlined";
import { useState } from "react";
import EditCategoriesModal from "./EditCategoriesModal";
import DataLabel from "components/DataLabel";
import { useAppSelector } from "app/hooks";
import { selectUserRole } from "features/auth/authSlice";
import { UserRole } from "features/auth/types/user";
import EmptyMessage from "components/EmptyMessage";

type CategoriesSectionProps = {
  checklist: Checklist;
};

const CategoryChip = styled(Chip)(() => ({
  fontSize: "medium",
}));

const CategoriesSection: React.FC<CategoriesSectionProps> = ({ checklist }) => {
  const [showDialog, setShowDialog] = useState(false);
  const userRole = useAppSelector(selectUserRole);
  const isAdmin = userRole === UserRole.ADMIN || userRole === UserRole.USER_ADMIN;
  const isSales = userRole === UserRole.SALES;

  return (
    <Box px={2} py={1}>
      <DataLabel label="Kategorier" />

      <Box display="flex" flexWrap="wrap" alignItems="center" gap={1} mb={1}>
        {checklist.categories.length > 0 ? (
          checklist.categories.map((category) => (
            <CategoryChip key={category} label={Categories[category]} />
          ))
        ) : (
          <EmptyMessage lineHeight="34px">Ingen kategori</EmptyMessage>
        )}

        {(isAdmin || isSales) && (
          <IconButton size="small" onClick={() => setShowDialog(true)}>
            <EditIcon />
          </IconButton>
        )}
      </Box>

      {showDialog && (
        <EditCategoriesModal
          checklistId={checklist.id}
          categories={checklist.categories}
          onClose={() => setShowDialog(false)}
        />
      )}
    </Box>
  );
};

export default CategoriesSection;
